import React, { Component } from "react"
import { connect } from "react-redux"
import trans from "trans"
import { find, forEach, sortBy, template } from "lodash"
import { ItemInterface, ReactSortable } from "react-sortablejs"
import { Link as RouterLink } from "react-router-dom"
import FileInputComponent from 'react-file-input-previews-base64'

import {
    css,
    confirm,
    Section,
    Checkbox,
    Tr,
    Td,
    Badge,
    Div,
    Button,
    PopupHint,
    Icon,
    Grid,
    Popup,
    TextInput,
    InputGroup,
    Spinner,
    Theme,
    GridCell,
    Link,
    Switcher,
} from "@bdfx/mergado-ui-kit"

import { Select } from '@mus/core'

import { RouterType, withRouter } from "app/components/routes"

import { AlternativeTemplate, AlternativeTemplatesLevels, Query, Template} from "app/types/model-types";

import {
    AltTemplatesReduxList,
    setAlternativeTemplatesToStore,
    setAlternativeTemplatesLevelsToStore,
    Templates,
} from "template-edit/reducers"

import { initForm } from "app/reducers/form"

import { RandomProduct } from "shape-edit/types";
import SectionLoader from "app/components/section-loader"
import { StyledTable, TemplateFilters } from "./templates-table"
import { URL } from "app/config/api-config"
import { ICONS_VERSION } from "shape-edit/forms/helpers"
import { SizeItem } from "settings/components/sizes-settings"
import { ID, ReduxList } from "app/types/app-types"
import { PopoverClose } from '@radix-ui/react-popover';
import { ActionType } from "./template-list"
import { deleteAlternativeTemplate, duplicateAlternativeTemplate, eshopId, getAlternativeTemplatesLevels, pauseAlternativeTemplate, projectId, redownloadAlternativeTemplate, renameAlternativeTemplate, rerenderAlternativeTemplate, startAlternativeTemplate, startOrPauseAlternativeTemplate, reorderAlternativeTemplates, changeBindings, changeLevelsAndMode, getAltTemplateDiagnostics } from "app/helpers/api"
import { AxiosResponse } from "axios"
import { availableLevels, LEVELS_MODE_SELECTED, LevelsModeType, levelsModeOptions, MAX_TEMPLATE_NAME_LENGHT, LEVELS_MODE_ALL } from "template-edit/components/save-template-form"
import { getTemplateTypeColor, getTemplateTypeIcon, getTemplateTypeTranslated, TemplateBadges } from "template-list/template-badges"
import Mergado from "app/helpers/mergado"
import { DiagnosticsPerAltTemplate, DiagnosticsPerTemplate } from "diagnostics/diagnostics"
import { testUsers } from "template-edit/components/helper"
import { createTemplateExport } from "app/reducers/exports"
import { iconDisabledColor } from "template-edit/components/tools-panel"

interface DispatchProps {
    diagnosticsPerTemplate: DiagnosticsPerTemplate[]
    isLoadingDiagnostics: boolean
    isImporting: boolean
    importTemplate: Function
    router: RouterType
    templates: Templates
    alternativeTemplates: AltTemplatesReduxList
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels>
    queries: ReduxList<Query[]>
    randomProduct: RandomProduct
    initForm: typeof initForm
    setAlternativeTemplatesToStore: typeof setAlternativeTemplatesToStore
    setAlternativeTemplatesLevelsToStore: typeof setAlternativeTemplatesLevelsToStore
    createTemplateExport: typeof createTemplateExport
    sizes: ReduxList<SizeItem>
    userId: number
}

type Props = DispatchProps
type EditType = 'name' | 'template' | 'levels' | null

type MainTemplateExtended = { template: Template & { product_count: number }, bindings: AlternativeTemplatesLevels }
type AlternativeTemplateExtended = { alternativeTemplate: AlternativeTemplate, assigned: MainTemplateExtended[] }   //(row)

interface ColumnConfig {
    header: React.ReactNode
    content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => JSX.Element
}

interface State {
    editId: ID | null
    editCol: number
    editType: EditType
    editName: string | null
    editTemplates: ID[]
    editLevelsMode: LevelsModeType | null
    editLevels: string[] | null
    activeColumns: string[]       // identificators of possible columns in table
    isLoading: boolean
    filters: TemplateFilters
    diagnosticsPerAltTemplate: DiagnosticsPerAltTemplate[]
    isLoadingAltDiagnostics: boolean
}

class AlternativeTemplatesTable extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            editId: null,
            editCol: null,
            editType: null,
            editName: null,
            editTemplates: [],
            editLevelsMode: null,
            editLevels: [],
            activeColumns: ["handle", "name", "preview", "format", "levels", "templates", "processed_alt_images", "products", "actions"],
            isLoading: false,
            filters: {
                name: '',
                error: '',
                active: "active",
                dynamicOnly: 0,
            },
            diagnosticsPerAltTemplate: null,
            isLoadingAltDiagnostics: null,
        }
    }

    updateData = () => {
        const { filters } = this.state
        getAltTemplateDiagnostics(filters.active === "active" ? 1 : 0, filters.name)
            .then((response: AxiosResponse<DiagnosticsPerAltTemplate[]>) => {
                this.setState({
                    diagnosticsPerAltTemplate: response.data,
                    isLoadingAltDiagnostics: true
                })
            })
            .catch(error => {
                console.debug('error while getting alternative template diagnostics', error)
            })
            .finally(() => {
                this.setState({ isLoadingAltDiagnostics: false })
            })
    }

    componentDidMount(): void {
        this.updateData()
    }

    componentDidUpdate(prevProps: Readonly<DispatchProps>, prevState: Readonly<State>, snapshot?: any): void {
        if (prevProps && JSON.stringify(prevProps.alternativeTemplatesLevels.data) !== JSON.stringify(this.props.alternativeTemplatesLevels.data)) {
            this.updateData()
        }
    }

    handleFilterName = (value: string) => {
        this.setState({
            filters: {
                ...this.state.filters,
                name: value
            },
        })
    }

    handleFilterActive = (value: "all" | "active" | "inactive") => {
        this.setState({
            filters: {
                ...this.state.filters,
                active: value
            },
        })
    }

    updateAltTemplateLevels = () => {
        getAlternativeTemplatesLevels()
            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                this.props.setAlternativeTemplatesLevelsToStore(response.data)
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })
    }

    handleStartOrPause = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })

        startOrPauseAlternativeTemplate(alternativeTemplate)
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                this.props.setAlternativeTemplatesToStore(response.data)
                this.handleFilterActive(alternativeTemplate.active ? "active" : "all")
            })
            .catch(error => {
                console.error("Error when pausing/starting alt template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handlePause = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })

        pauseAlternativeTemplate(alternativeTemplate)
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                this.props.setAlternativeTemplatesToStore(response.data)
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleStart = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })
        startAlternativeTemplate(alternativeTemplate)
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                this.props.setAlternativeTemplatesToStore(response.data)
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleRerender = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })
        rerenderAlternativeTemplate(alternativeTemplate.id)
            .then((response: AxiosResponse<any>) => {
                console.debug('renreder', response.data)
            })
            .catch((error) => {
                console.error("Error when re-rendering template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleRedownload = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })
        redownloadAlternativeTemplate(alternativeTemplate.id)
            .then((response: AxiosResponse<any>) => {
                console.debug('redownload', response.data)
            })
            .catch((error) => {
                console.error("Error when re-downloading alt template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    confirmBulkDelete = (ids: number[]) => confirm({
        message: trans("confirm__bulk_delete"),
        closeOnClickOutside: true,
        closeOnEscape: true,
        icon: <Icon type={'exclamation-triangle-radix'} color={Theme.red} />,
        style: {
            maxWidth: '350px',
            ' .muk-button': {
                width: '100%',
                margin: '0',
            },
            ' .muk-div': {
                borderTop: '0 !important',
                marginTop: '0 !important',
            },
            ' .muk-heading': {
                fontSize: '25px !important',
            },
        },
        buttons: [
            <Button key="yes" color={Theme.red} onClick={() => this.handleBulkAction('delete', ids)}>{trans("yes")}</Button>,
            <Button key="no" color={Theme.green}  onClick={() => false}>{trans("no")}</Button>
        ]
    })

    setColumns = (selectedColumns: string[]) => {
        this.setState({ activeColumns: [...selectedColumns] })
    }

    handleDuplicate = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })
        duplicateAlternativeTemplate(alternativeTemplate.id)
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                this.props.setAlternativeTemplatesToStore(response.data)
                this.updateAltTemplateLevels()
            })
            .catch((error) => {
                console.error('cannot duplicate template', error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }


    handleExport = (alternativeTemplateIds: ID[]) => {
        this.props.createTemplateExport(alternativeTemplateIds, true)
    }


    confirmDelete = (alternativeTemplate: AlternativeTemplate) => {
        confirm({
            message: trans("confirm_delete"),
            buttons: [
                <Button key="yes" onClick={() => this.handleDelete(alternativeTemplate)}>{trans("yes")}</Button>,
                <Button key="no" onClick={() => false}>{trans("no")}</Button>
            ]
        })
    }

    handleDelete = (alternativeTemplate: AlternativeTemplate) => {
        this.setState({ isLoading: true })
        deleteAlternativeTemplate(alternativeTemplate.id)
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                this.updateAltTemplateLevels()
                this.props.setAlternativeTemplatesToStore(response.data)
            })
            .catch((error) => {
                console.error("Error when deleting alternativeTemplate: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }


    handleBulkAction = (type: ActionType, ids: number[]) => {
        const { alternativeTemplates } = this.props

        if (type === 'export') {
            if (ids.length) {
                this.handleExport(ids)
            }

            return;
        }

        for (const id of ids) {
            const alternativeTemplate = find(alternativeTemplates.data, (t: AlternativeTemplate) => {
                return `${t.id}` === `${id}`
            })

            if (alternativeTemplate) {
                switch (type) {
                    case "start":
                        this.handleStart(alternativeTemplate)
                        break
                    case "pause":
                        this.handlePause(alternativeTemplate)
                        break
                    case "delete":
                        this.handleDelete(alternativeTemplate)
                        break
                    case "copy":
                        this.handleDuplicate(alternativeTemplate)
                        break;
                    case "rerender":
                        this.handleRerender(alternativeTemplate.id)
                        break;
                    case "redownload":
                        this.handleRedownload(alternativeTemplate.id)
                        break;
                    default:
                        break
                }
            } else {
                console.debug(`alternative template ${id} not found`)
            }
        }
    }


    renderPopUp = (row: number[] | AlternativeTemplate, button: JSX.Element) => {
        const {alternativeTemplatesLevels, templates} = this.props
        const style = {
            textAlign: "left",
            width: "100%"
        }

        const atls = Array.isArray(row) ? null :
            find(alternativeTemplatesLevels.data, (al: AlternativeTemplatesLevels) => {
                return `${row.id}` === `${al.alternative_template_id}`
            })

        const mainTemplate = atls ? find(templates.data, (t: Template) => {
            return `${t.id}` === `${atls.template_id}`
        }) : null

        return <Popup onOpenAutoFocus={(e) => e.preventDefault()} side="bottom" icon={button}>
            <Grid gap="5px">
                {Array.isArray(row) ?
                    <React.Fragment>
                        <Button onClick={() => this.handleBulkAction("start", row)} style={style} simple={true} icon="play-radix">{trans("start")}</Button>
                        <Button onClick={() => this.handleBulkAction("pause", row)} style={style} simple={true} icon="pause-radix">{trans("pause")}</Button>
                        <Button onClick={() => this.confirmBulkDelete(row)} style={style} simple={true} icon="trash-radix">{trans("delete")}</Button>
                        <Button onClick={() => this.handleBulkAction("export", row)} style={style} simple={true} icon="download-radix">{trans("export_template")}</Button>
                        <Button onClick={() => this.handleBulkAction("copy", row)} style={style} simple={true} icon="copy-radix">{trans("duplicate")}</Button>
                        {this.props.userId && testUsers.includes(this.props.userId) &&
                            <React.Fragment>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleBulkAction('rerender', row)} style={style} simple={true} icon="circle-o-notch" className="some-users-only">{trans("rerender")}</Button>
                                </PopoverClose>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleBulkAction('redownload', row)} style={style} simple={true} icon="download-light" className="some-users-only">{trans("redownload")}</Button>
                                </PopoverClose>
                            </React.Fragment>
                        }
                    </React.Fragment> :
                    <React.Fragment>
                        {/* TODO: */}
                        {/* <RouterLink to={`/eshop/${eshopId}/project/${projectId}/previews/template/${row.id}`}><Button style={style} simple={true} icon="magnifying-glass-radix">{trans("preview")}</Button></RouterLink> */}
                        <RouterLink to={`/eshop/${eshopId}/project/${projectId}/templates/${mainTemplate?.id}/edit-alt/${row.id}`}><Button style={style} simple={true} icon="pencil-1-radix">{trans("edit")}</Button></RouterLink>
                        {row.active ?
                            <Button onClick={() => this.handlePause(row)} style={style} simple={true} icon="pause-radix">{trans("pause")}</Button> :
                            <Button onClick={() => this.handleStart(row)} style={style} simple={true} icon="play-radix">{trans("start")}</Button>
                        }
                        <Button onClick={() => this.handleDuplicate(row)} style={style} simple={true} icon="copy-radix">{trans("duplicate")}</Button>
                        <PopoverClose asChild>
                            <Button onClick={() => this.handleExport([row.id])} style={style} simple={true} icon="download-radix">{trans("export_template")}</Button>
                        </PopoverClose>
                        <Button onClick={() => this.handleDelete(row)} style={style} simple={true} icon="trash-radix">{trans("delete")}</Button>

                        {this.props.userId && testUsers.includes(this.props.userId) &&
                            <React.Fragment>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleRerender(row)} style={style} simple={true} icon="circle-o-notch" className="some-users-only">{trans("rerender")}</Button>
                                </PopoverClose>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleRedownload(row)} style={style} simple={true} icon="download-light" className="some-users-only">{trans("redownload")}</Button>
                                </PopoverClose>
                            </React.Fragment>
                        }
                    </React.Fragment>}
            </Grid>
        </Popup>
    }

    renderActions = (selected: number[]) => {
        const { activeColumns, filters } = this.state

        return (
            <Grid className="actions" cols={`${selected.length > 0 ? "auto" : ""} 1fr auto auto auto auto`} gap="10px" valign="center">
                {selected.length > 0 &&
                    <div>
                        {this.renderPopUp(selected, <Button
                            icon={<Icon type="chevron-down-light" size={15} text={trans("selected") + " ..."} />}
                            size="small"
                        />)}
                    </div>
                }

                <TextInput small={true} type="search" value={filters.name} onChange={this.handleFilterName} placeholder={trans('fulltext')} />

                <Switcher value={filters.active} onChange={this.handleFilterActive} items={[
                    { label: trans('active_only'), value: "active" },
                    { label: trans('inactive'), value: "inactive" },
                    { label: trans('all'), value: "all" }
                ]} />

                <Popup side="bottom" icon={<Button size="smaller" color="#e4e4e7" secondary={true}><Icon type="columns" color="#333" text={trans('columns')} /></Button>}>
                    <InputGroup value={activeColumns} onChange={this.setColumns} search={true} orientation="vertical" items={
                        ["name", "preview", "format", "levels", "templates", "processed_alt_images", "products"].map((filter => {
                            return ({ label: trans(filter), value: filter })
                        }))
                    } />
                </Popup>

                <Grid cols="auto auto" style={{ ".IconButton > div": { marginTop: "0 !important", }, "> :nth-child(2)": { marginLeft: "-5px", borderLeft: "1px solid #68847d", ".muk-button": { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } } }}>
                    <PopupHint icon={
                        <FileInputComponent
                            key={'import_alt_template'}
                            labelText={null}
                            imagePreview={false}
                            multiple={false}
                            buttonComponent={
                                <Button
                                    color="green"
                                    icon={!this.props.isImporting ? "upload" : <Spinner color="blue" size={15} />}
                                    disabled={this.props.isImporting}
                                />
                            }
                            callbackFunction={(file: File) => this.props.importTemplate(file, true)}
                            accept="application/json"
                        />
                    }>
                        {trans("import_template")}
                    </PopupHint>
                </Grid>
            </Grid>
        )
    }

    getSortedList = (): AlternativeTemplateExtended[] => {
        const { templates, alternativeTemplates, alternativeTemplatesLevels } = this.props

        let list: AlternativeTemplateExtended[] = []

        const sortedLevels = sortBy(alternativeTemplatesLevels.data, [(atl) => -atl.priority])

        const seenIds = new Set<string>()

        sortedLevels.forEach((atl: AlternativeTemplatesLevels) => {
            const alternativeTemplate = find(alternativeTemplates.data, (at: AlternativeTemplate) => `${at.id}` === `${atl.alternative_template_id}`)
            if (!alternativeTemplate) return

            const mainTemplate = find(templates.data, (t: Template) => `${t.id}` === `${atl.template_id}`)
            if (!mainTemplate) return

            const altId = `${alternativeTemplate.id}`

            if (!seenIds.has(altId)) {
                seenIds.add(altId)
                list.push({ alternativeTemplate, assigned: [{ template: mainTemplate, bindings: atl }] })
            } else {
                find(list, (item) => `${item.alternativeTemplate.id}` === altId)?.assigned.push({ template: mainTemplate, bindings: atl })
            }
        })

        alternativeTemplates.data.forEach((alternativeTemplate: AlternativeTemplate) => {
            if (!seenIds.has(`${alternativeTemplate.id}`)) {
                list.push({ alternativeTemplate, assigned: [] })
            }
        })

        return list.filter((item: AlternativeTemplateExtended) => {
            if (this.state.filters.name !== "") {
                const filterName = this.state.filters.name.toLowerCase()
                const templateName = item.alternativeTemplate.name.toLowerCase()
                if (filterName !== "" && templateName.indexOf(filterName) === -1) {
                    return false
                }
            }
            if (this.state.filters.active !== "all") {
                if (this.state.filters.active === "active") {
                    if (item.alternativeTemplate.active !== 1) {
                        return false
                    }
                } else {
                    return !item.alternativeTemplate.active
                }
            }
            if (this.state.filters.dynamicOnly === 1) {
                if (item.alternativeTemplate.is_dynamic !== true) {
                    return false
                }
            }
            return true
        })
    }

    handleSubmit = () => {
        const { editType, editId, editName, editTemplates } = this.state
        const { alternativeTemplatesLevels, templates } = this.props

        const atls = find(alternativeTemplatesLevels.data, (al: AlternativeTemplatesLevels) => {
            return `${editId}` === `${al.alternative_template_id}`
        })

        const mainTemplate = atls ? find(templates.data, (t: Template) => {
            return `${t.id}` === `${atls.template_id}`
        }) : null


        switch (editType) {
            case 'name':
                renameAlternativeTemplate(editId, `${editName}`.substring(0, MAX_TEMPLATE_NAME_LENGHT))
                    .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                        this.props.setAlternativeTemplatesToStore(response.data)
                    })
                    .catch((e) => console.error('cannot rename template', e))
                    .finally(() => {
                        this.setEdit(null, null)
                    })
                break;
            case 'template':
                console.debug(`change main template id for alternative template id ${editId} from value ${mainTemplate?.id}  to  ${editTemplates}`)
                break;
            default:
                break;
        }

        this.setEdit(null, null)
    }

    setEdit = (editType: EditType, row: AlternativeTemplateExtended, col: number = 0) => {
        const b = row && row.alternativeTemplate && row.assigned ? find(row.assigned, (a) => {
            return `${row.alternativeTemplate.id}` === `${a?.bindings?.alternative_template_id}`
        }) : null

        this.setState({
            editType: editType,
            editId: row ? row.alternativeTemplate.id : null,   //TODO: rozlisit  editAlternativeTemplateId a editTemplateId??? pri editaci assigned templates
            editCol: col,
            editName: row ? row.alternativeTemplate.name : null,
            editTemplates: row ? row.assigned.map(a => `${a.template.id}`) : [],
            editLevelsMode: row && b ? b.bindings.levels_mode : null,
            editLevels: row && b && b.bindings && b.bindings.levels ? b.bindings.levels.split(',') : []
        })
    }

    render() {
        const { alternativeTemplates, alternativeTemplatesLevels, templates, queries, sizes, diagnosticsPerTemplate, isLoadingDiagnostics } = this.props
        const { editId, editCol, editType, editName, editTemplates, editLevels, editLevelsMode, diagnosticsPerAltTemplate, isLoadingAltDiagnostics } = this.state

        if (!alternativeTemplates.isLoaded || !alternativeTemplatesLevels.isLoaded || !sizes.isLoaded || !templates.isLoaded || !templates.data) {
            return <SectionLoader />
        }

        if (alternativeTemplates.isLoaded && alternativeTemplates.data?.length === 0) {
            return <span title={trans('no_alternative_templates')}  />
        }

        const availableTemplates = templates.data.map((t: Template) => {
            const text = getTemplateTypeTranslated(t.type)
            const color = getTemplateTypeColor(t.type)
            const icon = getTemplateTypeIcon(t.type, 20, t.active ? color : iconDisabledColor)

            return {
                text: <StyledTemplateOption>
                    <GridCell title={`${t.name} (${t.id})`} className={`template-name ${t.active ? '' : 'template-inactive'}`}>{t.name} {!t.active && <small>({trans('inactive').toLowerCase()})</small>}</GridCell>
                    <GridCell title={text}>{icon}</GridCell>
                </StyledTemplateOption>,
                label: `${t.name}`,
                value: `${t.id}`,
                active: t.active,
            }
        })

        const columns: Record<string, ColumnConfig> = ({
            "handle": {
                header: null,
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const isDraggableItem = alternativeTemplateExtended.alternativeTemplate.active && (alternativeTemplateExtended.assigned && alternativeTemplateExtended.assigned.length > 0)       /* staci alespon jedna vazba */

                    return <Td
                        key={`td_${isSelected ? 't' : 'f'}_${alternativeTemplateExtended.alternativeTemplate.id}`}
                        className={`${isDraggableItem ? 'handle' : ''} unselectable row-even`}
                        width="80px"
                        align="center"
                        style={{
                            position: "sticky",
                            zIndex: 2,
                            left: 0,
                            clipPath: "polygon(0 0%, 150% 0%,150% 150%,0% 150%)",
                            boxShadow: "1px 0px 3px rgba(0,0,0,0.08)",
                            cursor: isDraggableItem ? 'grab' : 'pointer',
                        }}>

                        {!!isDraggableItem && <Icon type="drag-handle-dots-2-radix" className="unhover" color="#888" size={18} />}

                        {this.props.userId && testUsers.includes(this.props.userId) &&
                            alternativeTemplateExtended.assigned.map((a) => <span className={'some-users-only'} key={`p_${a.bindings.id}_${a.bindings.priority}`}>{a.bindings.priority}</span>)
                        }

                        <br />
                        <Checkbox
                            style={{ display: "inline-block" }}
                            checked={isSelected}
                            value={true}
                            onChange={() => selectRow(alternativeTemplateExtended.alternativeTemplate.id)}
                        />
                    </Td>
                }
            },
            "name": {
                header: trans("name"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const atl = find(alternativeTemplatesLevels.data, (t: AlternativeTemplatesLevels) => {
                        return `${t.alternative_template_id}` === `${alternativeTemplateExtended.alternativeTemplate.id}`
                    })

                    const showEdit = `${editId}` === `${alternativeTemplateExtended.alternativeTemplate.id}` && editType === 'name'
                    const key = `td_name_${alternativeTemplateExtended.alternativeTemplate.id}`

                    return <Td key={key} align="left" style={{ position: "relative", gridTemplateColumns: "1fr auto", alignItems: "center", "&:hover .edit": { opacity: 1, pointerEvents: "all", } }} title={alternativeTemplateExtended.alternativeTemplate.updated_at}>
                        {showEdit ?
                            <Grid cols={'max-content auto max-content max-content'} gap={'10px'} style={{ ' .muk-gridcell': { alignSelf: 'center !important' } }}>
                                <GridCell>{trans("name")}</GridCell>
                                <GridCell>
                                    <TextInput
                                        small={true}
                                        value={editName}
                                        onChange={(value) => this.setState({ editName: value })}
                                    />
                                </GridCell>
                                <GridCell>
                                    <Button
                                        type={'void'}
                                        simple={true}
                                        icon={<Icon type={'check-slim'} color={Theme.green} />}
                                        onClick={this.handleSubmit}
                                    />
                                </GridCell>
                                <GridCell>
                                    <Button
                                        type={'void'}
                                        simple={true}
                                        icon={<Icon type={'close-light'} color={Theme.red} />}
                                        onClick={() => this.setEdit(null, null)}
                                    />
                                </GridCell>
                            </Grid>
                            :
                            <>
                                <div>
                                    <Div marginBottom="20px">
                                        <RouterLink to={`/eshop/${eshopId}/project/${projectId}/templates/${atl ? atl.template_id : 'null'}/edit-alt/${alternativeTemplateExtended.alternativeTemplate.id}`}>
                                            {alternativeTemplateExtended.alternativeTemplate.name}
                                        </RouterLink>
                                    </Div>

                                    <TemplateBadges template={alternativeTemplateExtended.alternativeTemplate} />
                                </div>

                                <Div position="absolute" top="5px" right="5px">
                                    <Button
                                        className="edit"
                                        onClick={() => this.setEdit('name', alternativeTemplateExtended)}
                                        simple={true}
                                        size="smaller"
                                        style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                        icon="pencil-1-radix"
                                    />
                                </Div>
                            </>
                        }
                    </Td>
                }
            },
            "preview": {
                header: trans("preview"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const timeStamp = new Date(`${alternativeTemplateExtended.alternativeTemplate.updated_at}`).getTime()
                    const thumbnailUrl = `${URL.laravelBase}alt-images/thumbs/thumbnail${alternativeTemplateExtended.alternativeTemplate.id}.${alternativeTemplateExtended.alternativeTemplate.is_anim_gif ? 'gif' : 'png'}?ts=${timeStamp}`
                    const key = `td_${alternativeTemplateExtended.alternativeTemplate.id}_preview_${alternativeTemplateExtended.alternativeTemplate.updated_at}`;

                    return <Td width="100px" key={key}>
                        <PopupHint icon={<img className="preview" style={{ maxWidth: "80px", maxHeight: "80px", boxShadow: "0px 0px 10px rgba(0,0,0,.1)", }} src={thumbnailUrl} />}>
                            <img className="preview" style={{ maxWidth: "400px", maxHeight: "400px" }} src={thumbnailUrl} />
                        </PopupHint>
                    </Td>
                }

            },
            "format": {
                header: trans("format"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const size = find(sizes.data, (size) => {
                        return `${alternativeTemplateExtended.alternativeTemplate.size_id}` === `${size.id}`
                    })
                    const key = `td_${alternativeTemplateExtended.alternativeTemplate.id}_format`

                    return <Td align="center" key={key}>
                        {!alternativeTemplateExtended.alternativeTemplate.is_keep_size && size?.format ?
                            <Div textAlign="center">
                                <PopupHint icon={<img className="logo" src={`${URL.laravelBase}img/icons/engines/${size.format}.svg?v=${ICONS_VERSION}`} />}>
                                    {size.format === "custom" ? trans('custom') : size.name}
                                </PopupHint>

                                <br />
                                <Badge small={true} secondary={true}>{size.width} x {size.height}</Badge>
                            </Div>
                            : trans("keep_original_image_size")
                        }
                    </Td>
                }
            },
            "levels": {
                header: trans("alt_levels"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const isAssigned = !!alternativeTemplateExtended.assigned.length
                    const showEdit = `${editId}` === `${alternativeTemplateExtended.alternativeTemplate?.id}` && isAssigned && editType === 'levels'
                    const key = `td_${alternativeTemplateExtended.alternativeTemplate.id}_levels`

                    return <Td align="center" key={key} style={{ gridTemplateColumns: "1fr auto", alignItems: "center", "&:hover .edit": { opacity: 1, pointerEvents: "all", } }}>
                        {isAssigned ?
                            <StyledGrid>
                                {alternativeTemplateExtended.assigned.map((a: MainTemplateExtended, index: number) => {
                                    const availableLevelsModeOptions = levelsModeOptions(null, null)
                                    const availableLevelsOptions = availableLevels(null)
                                    const showThisEdit = showEdit && index === editCol

                                    return <GridCell key={`alt_${alternativeTemplateExtended.alternativeTemplate.id}_${a.template.id}_${editLevelsMode}`} style={{  position: "relative" }}>
                                        {!showThisEdit ?
                                            <React.Fragment>
                                                {trans(a.bindings.levels_mode || LEVELS_MODE_ALL)}
                                                {(a.bindings.levels_mode === LEVELS_MODE_SELECTED && a.bindings?.levels) && `: ${a.bindings.levels.split(',').map(l => `${parseInt(l) + 1}`).join(', ')}`}
                                            </React.Fragment> :
                                            <React.Fragment>
                                                <Grid cols={'auto max-content max-content'} gap={'10px'} style={{ ' .muk-gridcell': { alignSelf: 'center !important' } }}>
                                                    <GridCell>
                                                        <Grid cols={'40% 60%'}>
                                                            <GridCell col={editLevelsMode !== LEVELS_MODE_SELECTED ? '1/-1' : undefined}>
                                                                <Select
                                                                    title={trans('mode')}
                                                                    placeholder={trans('all')}
                                                                    options={availableLevelsModeOptions}
                                                                    value={editLevelsMode}
                                                                    className={'left'}
                                                                    onChange={(newValue) => {
                                                                        this.setState({ editLevelsMode: newValue })
                                                                        changeLevelsAndMode(alternativeTemplateExtended.alternativeTemplate.id, a.bindings.template_id, newValue, a.bindings.levels)
                                                                            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                                                                                this.props.setAlternativeTemplatesLevelsToStore(response.data)
                                                                            })
                                                                            .catch((e) => {
                                                                                console.error('cannot change mode', e)
                                                                            })
                                                                    }}
                                                                />
                                                            </GridCell>

                                                            {editLevelsMode === LEVELS_MODE_SELECTED &&
                                                                <GridCell>
                                                                    <Select
                                                                        title={trans('alt_levels')}
                                                                        isMulti
                                                                        options={availableLevelsOptions}
                                                                        value={editLevels}
                                                                        className={'left'}
                                                                        style={{ textAlign: 'center' }}
                                                                        onChange={(newValue) => {
                                                                            const sortedE = sortBy(newValue).filter(v => v !== null)
                                                                            this.setState({ editLevels: sortedE })
                                                                            changeLevelsAndMode(a.bindings.alternative_template_id, a.bindings.template_id, a.bindings.levels_mode, sortedE.join(','))
                                                                                .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                                                                                    this.props.setAlternativeTemplatesLevelsToStore(response.data)
                                                                                })
                                                                                .catch((e) => {
                                                                                    console.error('cannot change levels mode', e)
                                                                                })
                                                                        }}
                                                                    />
                                                                </GridCell>
                                                            }
                                                        </Grid>
                                                    </GridCell>
                                                    <GridCell>
                                                        <Button
                                                            type={'void'}
                                                            simple={true}
                                                            icon={<Icon type={'check-slim'} color={Theme.green} />}
                                                            onClick={() => {
                                                                this.handleSubmit()
                                                            }}
                                                        />
                                                    </GridCell>
                                                    <GridCell>
                                                        <Button
                                                            type={'void'}
                                                            simple={true}
                                                            icon={<Icon type={'close-light'} color={Theme.red} />}
                                                            onClick={() => this.setEdit(null, null, index)}
                                                        />
                                                    </GridCell>
                                                </Grid>
                                            </React.Fragment>
                                        }

                                        {!showThisEdit && isAssigned && /* this.props.userId && testUsers.includes(this.props.userId) && */
                                            <Div position="absolute" top="2px" right="5px">
                                                <Button
                                                    className="edit"
                                                    onClick={() => this.setEdit('levels', alternativeTemplateExtended, index)}
                                                    simple={true}
                                                    size="smaller"
                                                    style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                                    icon="pencil-1-radix"
                                                />
                                            </Div>
                                        }
                                    </GridCell>
                                })}
                            </StyledGrid> :
                            <Badge>{trans('no_assigned_templates')}</Badge>
                        }
                    </Td>
                },
            },
            "processed_alt_images": {
                header: trans("processed_alt_images"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const diagnostics = diagnosticsPerAltTemplate ? find(diagnosticsPerAltTemplate, (d) => {
                        return `${d.altTemplateId}` === `${alternativeTemplateExtended.alternativeTemplate.id}`
                    }) : null
                    return <Td align="center" key={`td_${alternativeTemplateExtended.alternativeTemplate.id}_${diagnostics ? 'd' : 'n'}`}>
                        {diagnostics ?
                            <React.Fragment>
                                <Icon type={'check'} color={Theme.green} text={`${diagnostics.statusOk}`} /><br />
                                <Icon type={'exclamation-triangle-radix'} color={Theme.red} text={`${diagnostics.statusError}`} /><br/>
                                <span>{diagnostics.processedAltImages}</span><br/>
                            </React.Fragment>
                            : <Spinner type={'bubbles'} />
                        }

                        <Div position="absolute" top="5px" right="5px">
                            <Button
                                className="edit"
                                onClick={() => this.setEdit('template', alternativeTemplateExtended)}
                                simple={true}
                                size="smaller"
                                style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                icon="pencil-1-radix"
                            />
                        </Div>
                    </Td>
                }
            },
            "products": {
                header: trans("products"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const atls = find(alternativeTemplatesLevels.data, (al: AlternativeTemplatesLevels) => {
                        return `${alternativeTemplateExtended.alternativeTemplate.id}` === `${al.alternative_template_id}`
                    })

                    if (!queries.isLoaded || !alternativeTemplatesLevels) {
                        return <Td align="center" key={`td_${alternativeTemplateExtended.alternativeTemplate.id}_products`} />
                    }

                    const mainTemplate = atls ? find(templates.data, (t: Template) => {
                        return `${t.id}` === `${atls.template_id}`
                    }) : null

                    const diagnostics = !isLoadingDiagnostics && mainTemplate && diagnosticsPerTemplate ? find(diagnosticsPerTemplate, (diagnosticsPerTemplate) => {
                        return `${diagnosticsPerTemplate.template_id}` === `${mainTemplate.id}`
                    }) : null

                    return <Td align="center" key={`td_${alternativeTemplateExtended.alternativeTemplate.id}_products`}>
                        {mainTemplate ?
                            <Grid cols={'auto'} gap={'4px'} className="queries">
                                <GridCell className='total-products clickable' title={trans('total_products')}>
                                    {diagnostics && diagnostics.totalProducts}
                                    {isLoadingDiagnostics && <Spinner />}
                                </GridCell>

                                {mainTemplate.queries && mainTemplate.queries.length &&
                                    mainTemplate.queries.map((queryId: ID, i: number) => {
                                    const query = find(this.props.queries.data, (query: Query) => {
                                        return query.id === queryId
                                    })
                                    if (!query) {
                                        return <GridCell key={queryId} />
                                    }
                                    if (i === 0) {
                                        return <GridCell key={queryId}>
                                            <Link title={trans('show_in_mergado')} onClick={() => Mergado.openWindow(`https://app.mergado.com/projects/${projectId}/queries/edit/${queryId}`)}>
                                                <small>({query.name === '♥ALLPRODUCTS♥' ? trans('all_products') : query.name})</small>
                                                <br />
                                                {mainTemplate?.queries.length > 1 && (
                                                    <Badge onClick={(e: React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); return false; }} color={Theme.blue}>+ {alternativeTemplateExtended.alternativeTemplate?.queries?.length - 1} další</Badge>
                                                )}
                                            </Link>
                                        </GridCell>
                                    } else {
                                        return null
                                    }
                                })}
                            </Grid> :
                            <Badge>{trans('no_assigned_templates')}</Badge>
                        }
                    </Td>
                }
            },
            "templates": {
                header: trans("assigned_templates"),
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    const showEdit = `${editId}` === `${alternativeTemplateExtended.alternativeTemplate.id}` && editType === 'template' && availableTemplates
                    const key = `td_${alternativeTemplateExtended.alternativeTemplate.id}_templates`

                    return <Td align="center" key={key} style={{ position: "relative", gridTemplateColumns: "1fr auto", alignItems: "center", "&:hover .edit": { opacity: 1, pointerEvents: "all", } }}>
                        {!showEdit ?
                            <React.Fragment>
                                {alternativeTemplateExtended.assigned.length ?
                                    <StyledGrid>
                                        {alternativeTemplateExtended.assigned.map((a: MainTemplateExtended, index: number) => {
                                            const showThisEdit = showEdit && index === editCol
                                            return <GridCell key={`alt2_${a.bindings.id}_${alternativeTemplateExtended.alternativeTemplate.id}`}>
                                                <div>
                                                    <img
                                                        className={'preview'}
                                                        src={`${URL.laravelBase}images/thumbs/thumbnail${a.template.id}.png`}
                                                        title={a.bindings.levels ? `${trans('alt_levels')} ${a.bindings.levels}` : ''}
                                                    />
                                                </div>
                                                <div>{a.template.name}</div>
                                                <div>{a.template.product_count}</div>
                                            </GridCell >
                                        }
                                        )}
                                    </StyledGrid> : <Badge>{trans('no_assigned_templates')}</Badge>
                                }

                                <Div position="absolute" top="5px" right="5px">
                                    <Button
                                        className="edit"
                                        onClick={() => this.setEdit('template', alternativeTemplateExtended)}
                                        simple={true}
                                        size="smaller"
                                        style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                        icon="pencil-1-radix"
                                    />
                                </Div>
                            </React.Fragment>
                            :
                            <Grid cols={'auto max-content max-content'} gap={'10px'} style={{ ' .muk-gridcell': { alignSelf: 'center !important' } }}>
                                <GridCell>
                                    <Select
                                        value={editTemplates}
                                        isMulti
                                        options={availableTemplates}
                                        onClear={() => this.setState({ editTemplates: [] })}
                                        onChange={(newMainTemplateIds) => {
                                            this.setState({ editTemplates: newMainTemplateIds })
                                            changeBindings(alternativeTemplateExtended.alternativeTemplate.id, newMainTemplateIds)
                                                .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                                                    this.props.setAlternativeTemplatesLevelsToStore(response.data)
                                                })
                                                .catch((e) => {
                                                    console.error('cannot change bindings', e)
                                                })
                                        }}
                                    />
                                </GridCell>
                                <GridCell>
                                    <Button
                                        type={'void'}
                                        simple={true}
                                        icon={<Icon type={'check-slim'} color={Theme.green} />}
                                        onClick={this.handleSubmit}
                                    />
                                </GridCell>
                                <GridCell>
                                    <Button
                                        type={'void'}
                                        simple={true}
                                        icon={<Icon type={'close-light'} color={Theme.red} />}
                                        onClick={() => this.setEdit(null, null)}
                                    />
                                </GridCell>
                            </Grid>
                        }
                    </Td>
                }
            },
            "actions": {
                header: <div style={{ position: "sticky", right: 0, background: "white", width: '65px', textAlign: 'center' }}>
                    {trans("action")}
                </div>,
                content: (alternativeTemplateExtended: AlternativeTemplateExtended, isSelected: boolean, selectRow: Function) => {
                    return (
                        <Td key={`td_${alternativeTemplateExtended.alternativeTemplate.id}_row`} align="center" className="row-even" width="60px" style={{ textAlign: '-webkit-center', position: "sticky", right: 0, clipPath: "polygon(-10% 0%, 100% 0%,100% 100%,-10% 100%)", boxShadow: "-1px 0px 3px rgba(0,0,0,0.08)" }}>
                            {this.renderPopUp(alternativeTemplateExtended.alternativeTemplate, <Button icon={<Icon type="ellypsis-vertical-light" color="blue" size={15} />} color="#eee" style={{ background: "white" }} secondary={true} size="small" />)}
                        </Td>
                    )
                }
            },
        })

        const activeColumns = Object.entries(columns).filter(([id, properties]) => this.state.activeColumns.indexOf(id) > -1).map(([id, properties]) => ({ ...properties, columnId: id }))
        const showColumns = [...activeColumns]

        const alternativeTemplatelist = this.getSortedList()
        const alternativeTemplateKeys = alternativeTemplates.data.map(t => `${t.id}_${t.active ? 'a' : 'i'}_${t.updated_at}`).join(',') + (isLoadingDiagnostics ? 'ld' : 'd')
        const alternativeTemplatesLevelsKey = alternativeTemplatesLevels.data.map((al: AlternativeTemplatesLevels) => `${al.id}_${al.template_id}_${al.alternative_template_id}_${al.levels_mode}_${al.levels}`).join(',')

        const alternativeTemplateIds = alternativeTemplates.data.map(t => parseInt(`${t.id}`))
        const templateKeys = alternativeTemplates.data.map(t => `${t.id}_${t.active ? 'a' : 'i'}`).join(',')

        const list = alternativeTemplatelist.map(t => ({ id: t.alternativeTemplate.id }))

        const reorderAltTemplates = (newList: ItemInterface[]) => {
            const ids = newList.filter(l => !!l).map(l => l.id)
            const currentIdsOrder = alternativeTemplatelist.map(t => t.alternativeTemplate.id)

            if (currentIdsOrder.join(',') !== ids.join(',')) {
                console.debug(`DIFF: set newList ${ids.join(',')} list before: ${currentIdsOrder.join(',')}`)

                reorderAlternativeTemplates(ids)
                    .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                        this.props.setAlternativeTemplatesLevelsToStore(response.data)
                    })
                    .catch((error) => console.error('cannot update priority', error))
            }
        }

        const orderedList = (selected: ID[], toggle: Function) => alternativeTemplatelist.map((alternativeTemplateExtended: AlternativeTemplateExtended, orderIndex: number) => {
            const isSelected = selected.indexOf(alternativeTemplateExtended.alternativeTemplate.id) > -1
            const dtkey = showColumns.join(',') + "-" + templateKeys + "-" + "-" + isSelected + alternativeTemplateExtended.alternativeTemplate.id + "-" + alternativeTemplateExtended.alternativeTemplate.name + "-" + editId

            return <Tr rowId={alternativeTemplateExtended.alternativeTemplate.id} isOdd={true} key={dtkey}>
                {showColumns.map(column => {
                    return columns[column.columnId].content(alternativeTemplateExtended, isSelected, toggle)
                })}
            </Tr>
        })

        return (
            <Section header={trans('alternative_templates')}>
                <StyledTable
                    key={`table${alternativeTemplateKeys}${alternativeTemplatesLevelsKey}${isLoadingAltDiagnostics}`}
                    ids={alternativeTemplateIds}
                    actions={this.renderActions}
                    header={showColumns.filter(c => c.header).map((c, i) => <React.Fragment key={`header_table_${i}`}>{c.header}</React.Fragment>)}>
                    {(selected, toggle) => <ReactSortable
                        filter=".inactive"
                        list={list}
                        setList={reorderAltTemplates}
                        animation={150}
                        ghostClass="ghost"
                        handle=".handle" tag="tbody" style={{ display: "contents" }}>
                        {orderedList(selected, toggle)}
                    </ReactSortable>
                    }
                </StyledTable>
            </Section>
        )
    }
}

const StyledTemplateOption = css(Grid)({
    gridTemplateColumns: 'auto 24px',
    width: '100%',
    ' .template-inactive': {
        fontStyle: 'italic',
        color: iconDisabledColor,
    }
})

const StyledGrid = css(Grid)({
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gridAutoFlow: 'row !important',
    gridGap: '2px',
    border: '0px solid #ffffff',
})

function mapStateToProps(state) {
    return {
        templates: state.templates,
        alternativeTemplates: state.alternativeTemplates,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        randomProduct: state.randomProduct,
        userId: state.project.data.user?.id,
        sizes: state.sizes,
        queries: state.queries,
    }
}

export default connect(mapStateToProps, {
    initForm,
    setAlternativeTemplatesToStore,
    setAlternativeTemplatesLevelsToStore,
    createTemplateExport,
})(withRouter(AlternativeTemplatesTable));